export const makeBFFApiUrl = (path: string): string => path;
